import { type ComponentType } from 'react';
import { NewContainer } from './inject_react';

/**
 * @deprecated Avoid wrapping components in dependency injection containers. Use React context/state and custom hooks instead.
 */
export function withNewContainer<T extends Record<string, unknown>>(Component: ComponentType<T>) {
	return function withNewContainer(props: T) {
		return <NewContainer>{<Component {...props} />}</NewContainer>;
	};
}
